import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Installation_of_high_altitude_infrastructures() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>     התקנת תשתיות בגובה</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Installation_of_high_altitude_infrastructures">   התקנת תשתיות בגובה</Link>{" "}
</div>
    </div>
        <div className="video-line" />
<div className="video-box2">
  <iframe
    width="100%"
    height="400"
    src="https://www.youtube.com/embed/rZeK7XW9PSI?start=11"
    title="YouTube video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
</div>
      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">


      <div className="image-box2">
        <img src="/images/5.jpg" alt="roof" />
      </div>
      <div className="text-box">


  <h2 className="info-title">   במקרים רבים אנו צריכים לבצע עבודות איטום שונות כגון

</h2>
  <ul className="info-list">
    <li>  איטום של פתח מיזוג,</li>
    <li>התקנת צנרת ניקוז</li>
    <li>טייח חיצוני</li>
      <li> איטום קירות חיצוניים</li>
    <li>הרחקת יונים</li>
    <li>ועוד</li>
  </ul>

       <p>  
כאשר ידיו של הקבלן אינם מגיעות למקומות הנ"ל אתם מוזמנים להעזר בחברת "איטומים בגבהים".
אנו נעמיד לרשותכם צוות סנפלינג שיבצע את העבודה עבורכם.</p>
    <p>  
צוותי הסנפלינג שלנו הוא צוות מקצועי ומיומן המאושר לביצוע עבודות אלו ע"י מהנדסי הבניין של משרד העבודה
</p>


  <h2 className="info-title">   ולנו קיים כיסוי ביטוחי לכל עבודה שאנו מבצעים. 



</h2>
      </div>

    </div>




    <ContactSection2/>
<div className="links2">


  <Link to="/Sealing_Wet_Rooms" className="link-right" > איטום חדרים רטובים</Link>
  <Link to="/Betkal_Casting" className="link-left" >  יציקת בטקל </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


